export { AdaptiveHeading } from './AdaptiveHeading';
